import React from 'react'
import { useAuth } from '../context/Auth'
import { useTranslation } from 'react-i18next'
import './AccessRestricted.scss'

declare const RESTRICTED_ACCESS_HELP_EMAIL: string

export default function AccessRestricted() {
  const authState = useAuth().state
  const { keycloak, profile } = authState
  const { firstName, username } = profile
  const { t } = useTranslation()

  const name = profile ? firstName || username : t('user')
  const realm = (keycloak?.realm || '').toUpperCase()

  return (
    <div className="AccessRestricted">
      <h1>{t('accessRestricted')}</h1>
      <p>{t('sorryNoAccess')}</p>
      <p>
        {t('pleaseContact')}{' '}
        <a href={`mailto:${RESTRICTED_ACCESS_HELP_EMAIL}`}>
          {RESTRICTED_ACCESS_HELP_EMAIL}
        </a>
        {''}
        {t('forMoreInfo')}
      </p>
      <p>
        {t('youCanAlso')}{' '}
        <a
          href="/"
          onClick={(e) => {
            e.preventDefault()
            keycloak?.logout()
          }}
        >
          {t('signOut')}
        </a>{' '}
        {t('andTryAgain')}
      </p>
      <p>{t('apologiesForTheInconvenience')}</p>
    </div>
  )
}
